import React, { ReactNode } from 'react';
import { Modal, Button } from 'antd';

interface CustomModalProps {
  visible: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  title: string;
  backBtnText: string;
  submitBtnText: string;
  children?: ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = (props) => {
  const { visible, handleOk, handleCancel, title, backBtnText, submitBtnText, children } = props;

  return (
    <Modal
      visible={visible}
      title={title}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          {backBtnText}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          <i className="fa fa-paper-plane mr-3" aria-hidden="true"></i>
          {submitBtnText}
        </Button>,
      ]}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
